import AppConstants from '@/shared/app/model/AppConstants';
import Dataset from '../model/Dataset';

export function notInProduction(values: Dataset): Dataset {
  if (
    process.env.NODE_ENV !== AppConstants.ENV.PRODUCTION &&
    !window.location.search.includes('mocks=0')
  )
    return values;
  return {};
}
